import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ContactusComponent } from "..//../contactus/contactus.component";
import { CookieService } from "ngx-cookie-service";
import { ActivatedRoute } from "@angular/router";
import * as welcomeData from "../../../assets/welcome.json";
import { environment } from "../../../environments/environment";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.css"],
})
export class FooterComponent implements OnInit {
  landingData: any = (welcomeData as any).default;
  userCookie: any;
  cookiesCheck = false;
  activeStatus: any;
  @Output() Navigate = new EventEmitter();
  appConstant: any;
  constructor(
    public dialog: MatDialog,
    private cookieService: CookieService,
    private router: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.appConstant = environment;
    this.router.queryParams.subscribe((params) => {
      if (params["data"]) {
        this.activeStatus = params["data"];
      }
    });
    this.userCookie = this.cookieService.get("userCookie");
    if (this.userCookie) {
      this.cookiesCheck = true;
    }
  }

  navigateTo(element: string): any {
    this.activeStatus = element;
    this.Navigate.emit(element);
  }
  openDialog() {
    const dialogRef = this.dialog.open(ContactusComponent, {
      width: "600px",
    });

    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
      }
    });
  }

  setCookies() {
    this.cookiesCheck = true;
    this.cookieService.set("userCookie", "true", { expires: 15 });
  }
  closeCookies(){
    this.cookiesCheck = true;
  }
}
